import React from "react";
import FetchTVShows from "../../components/FetchTVShows/FetchTVShows";

const PopularTVShows = () => {
  return <FetchTVShows slug="popular" pageTitle="Popular" />;
};

export default PopularTVShows;
